var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRadioDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "disabled",
    cx: 20.5548,
    cy: 20.6408,
    r: 19.1934,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.53547
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRadioDisabled);
export default "/Frontend/static/media/radio-disabled.2f28dc0239ed50404b009f4d761a2542.svg";
export { ForwardRef as ReactComponent };